import { useEffect, useState } from "react";

const REQUEST = "Hydrating facial and brow shaping tonight, after 6 — near SoHo";
const CHIPS = [["Hydrating Facial", "mint"], ["Brow Shaping", "lilac"], ["Tonight · after 6:00 PM", "blush"]];
const ORDER = ["typing", "chips", "plan", "confirmed", "out"];
const TONE = { mint: ["var(--mint)", "#1F5C3A"], lilac: ["var(--lilac)", "#4B3A7A"], blush: ["var(--blush)", "var(--burgundy)"] };

export default function HeroPhone() {
  const [typed, setTyped] = useState(0);
  const [phase, setPhase] = useState("typing");
  const at = (p) => ORDER.indexOf(phase) >= ORDER.indexOf(p) && phase !== "out";

  useEffect(() => {
    let alive = true;
    const wait = (ms) => new Promise((r) => setTimeout(r, ms)).then(() => { if (!alive) throw new Error("stop"); });
    (async () => {
      try {
        while (alive) {
          setPhase("typing"); setTyped(0);
          await wait(900);
          for (let i = 1; i <= REQUEST.length; i++) { setTyped(i); await wait(34 + Math.random() * 40); }
          await wait(700); setPhase("chips");
          await wait(2200); setPhase("plan");
          await wait(3400); setPhase("confirmed");
          await wait(3600); setPhase("out");
          await wait(800);
        }
      } catch (e) { /* loop stopped on unmount */ }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div className="hp-wrap" data-testid="hero-phone" data-phase={phase}>
      <div className="hp-float">
        <div className="phone-mock hp-phone">
          <div className="hp-screen">
            <div className={`hp-content ${phase === "out" ? "hp-out" : ""}`}>
            <div className="hp-status"><span>6:04</span><span className="hp-dots"><i /><i /><i /><b /></span></div>
            <div className="hp-brand"><span className="wordmark">marova</span><span>assistant</span></div>

            <div className="hp-bubble hp-user">
              {REQUEST.slice(0, typed)}<span className={`hp-caret ${phase === "typing" ? "" : "hp-hide"}`} />
            </div>

            <div className={`hp-bubble hp-bot ${at("chips") ? "in" : ""}`}>
              <div className="serif hp-bot-title">Got it. Here's what I understood:</div>
              <div className="hp-chips">
                {CHIPS.map(([c, t], i) => (
                  <span key={c} className={`hp-chip ${at("chips") ? "in" : ""}`} style={{ background: TONE[t][0], color: TONE[t][1], transitionDelay: `${180 + i * 220}ms` }}>{c}</span>
                ))}
              </div>
            </div>

            <div className={`hp-plan ${at("plan") ? "in" : ""}`}>
              <div className="hp-plan-head"><span>Aura Med Spa suggested a plan</span><span className="hp-live" /></div>
              {[["6:15 PM", "Hydrating Facial · Maya", "$110", "mint"], ["7:20 PM", "Brow Shaping · Lena", "$55", "lilac"]].map(([t, s, p, tone], i) => (
                <div key={t} className={`hp-row ${at("plan") ? "in" : ""}`} style={{ transitionDelay: `${300 + i * 260}ms` }}>
                  <i style={{ background: TONE[tone][1] }} /><b>{t}</b><span>{s}</span><em>{p}</em>
                </div>
              ))}
              <div className={`hp-total ${at("plan") ? "in" : ""}`} style={{ transitionDelay: "900ms" }}><span>Total</span><b>$165</b></div>
              <div className={`hp-cta ${at("confirmed") ? "hp-cta-done" : ""} ${at("plan") ? "in" : ""}`} style={{ transitionDelay: "1100ms" }}>{at("confirmed") ? "Confirmed" : "Accept plan"}</div>
            </div>

            <div className={`hp-confirm ${at("confirmed") ? "in" : ""}`}>
              <svg viewBox="0 0 64 64" width="72" height="72">
                <circle cx="32" cy="32" r="30" fill="var(--mint)" />
                <path d="M19 33 L28 42 L46 23" fill="none" stroke="#1F5C3A" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" className="hp-check" />
              </svg>
              <div className="serif hp-confirm-title">You're confirmed</div>
              <div className="hp-confirm-sub">Tonight · Aura Med Spa · added to calendar</div>
            </div>
            </div>
          </div>
        </div>
        <div className="hp-glow" />
      </div>
    </div>
  );
}
